import React from 'react';
import { Row, Col, Form, message, Input } from 'antd';
import { Title } from '@/components/Typography';
import debounce from 'lodash/debounce';

import { useApplicationContext } from '@/context/v1/Application/context';
import { useUpdateComment } from '@/hooks/useUpdateBackCompressiveForceEstimation';
import { useBackCompressiveForceEstimationContext } from '../../context';
import { UpdateComment } from '../../types';

const { TextArea } = Input;

interface CommentProps {
	disableEditComment: boolean;
	onCommentChange: (editingComment: boolean) => void;
}

const { useFormInstance } = Form;

export const Comment: React.FC<CommentProps> = ({ onCommentChange, disableEditComment }) => {
	const { setFieldValue } = useFormInstance();
	const { backCompressiveForceEstimation } = useBackCompressiveForceEstimationContext();
	const { organization, company } = useApplicationContext();

	const [, contextHolder] = message.useMessage();
	const { mutateAsync, isLoading } = useUpdateComment();

	const setComment = debounce(async (value) => {
		onCommentChange(true);
		await updateComment(value);
		onCommentChange(false);
	}, 1200);

	async function updateComment(text: string) {
		const parameters: UpdateComment = {
			comment: text,
			company_id: company.id,
			report_id: backCompressiveForceEstimation.id,
			organization_id: organization.id
		};

		const updatedComment = await mutateAsync(parameters);
		if (updatedComment?.id) {
			setFieldValue('comment', updatedComment.comment);
		}
	}

	function handleChange(text: string) {
		setComment(text);
	}

	return (
		<Row gutter={[0, 24]}>
			<Col xs={24}>
				<Row gutter={[16, 16]}>
					<Col xs={24}>
						<Title style={{ margin: 0 }} level={4}>
							Comment
						</Title>
						{contextHolder}
					</Col>
					<Col xs={24}>
						<Form.Item name={['comment']} labelCol={{ xs: 24 }}>
							<TextArea
								rows={4}
								maxLength={500}
								showCount={true}
								onChange={(event) => handleChange(event.target.value)}
								disabled={isLoading || disableEditComment}
							/>
						</Form.Item>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};
